<template>
  <div :class="['d-none d-sm-block privacy-screen privacy-screen-backdrop', {'privacy-backdrop-active': screenActive}]">
    <div
      v-if="screenActive"
      class="pa-0 ma-0 d-flex h-100 justify-center align-center privacy-screen"
    >
      <v-chip
        class="privacy-screen-chip"
        label
        outlined
        x-large
        color="primary px-6"
      >
        <v-icon class="mr-4">
          mdi-eye-lock-outline
        </v-icon>
        {{ $t('label.privacy_screen_active') }}
      </v-chip>
    </div>
  </div>
</template>

<script setup lang="ts">

import store from '@/store/store';
import {
  ref, onBeforeUnmount, onMounted, computed, watch,
} from 'vue';

const props = defineProps({
  top: { type: String, required: false, default: '0px' },
  left: { type: String, required: false, default: '0px' },
  maxWidth: { type: String, required: false, default: '100%' },
});

const screenActive = ref(false);
const timeout = computed(() => (store.getters.activeUser?.privacyScreenTimeout || 0) * 1000);
let timer = undefined as number | undefined;

const activityHandler = () => {
  if (timeout.value === 0) { return; }

  screenActive.value = false;
  if (timer !== undefined) { window.clearTimeout(timer); }
  timer = window.setTimeout(() => {
    screenActive.value = true;
  }, timeout.value);
};

watch(timeout, () => {
  if (timeout.value === 0) {
    screenActive.value = false;
    if (timer !== undefined) { window.clearTimeout(timer); }
  } else {
    activityHandler();
  }
});

const events = ['mousemove', 'keydown', 'wheel', 'click'];
events.forEach((e) => window.addEventListener(e, activityHandler));

onMounted(() => activityHandler());
onBeforeUnmount(() => {
  events.forEach((e) => window.removeEventListener(e, activityHandler));
});

</script>

<style scoped lang="scss">
.privacy-screen {
  top: v-bind(top);
  left: 0px;
  width: 100%;
  z-index: 1000;
  will-change: opacity, height;
  transition: opacity 0.001s;
  pointer-events: none;
}

.privacy-screen-backdrop {
  left: v-bind(left);
  opacity: 0;
  position: fixed;
  max-width: v-bind(maxWidth);
}

.privacy-backdrop-active {
  height: calc(100% - v-bind(top));
  opacity: 1;
  transition: opacity 0.25s;
  backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px);
}

.privacy-screen-chip {
  left: calc(v-bind(left) * -1);
}

</style>
